const getThumbnailUrl = <T extends string | null | undefined = string>(
  url: T,
  opts?: { size?: 300 | 600 | 1200; mode?: "crop" | "resize" },
): T extends null | undefined ? null : string => {
  opts = {
    size: 300,
    mode: "crop",
    ...opts,
  };
  const { size, mode } = opts;
  if (!url) {
    return null as T extends null | undefined ? null : string;
  }
  const path = url
    .replace("https://griptonite-media.s3.amazonaws.com/", "")
    .replace("https://media.griptonite.io/", "");
  const parts = path.split("/");
  const prefix = parts[0];
  const stemPath = parts.slice(1).join("/").split(".")[0];

  return `https://media-processed.griptonite.io/${prefix}/${mode}/${size}x${size}/${stemPath}.jpg` as T extends
    | null
    | undefined
    ? null
    : string;
};

export const getVideoThumbnailUrl = <T extends string | null | undefined = string>(
  url: T,
): T extends null | undefined ? null : string => {
  if (!url) {
    return null as T extends null | undefined ? null : string;
  }
  const path = url
    .replace("https://griptonite-media.s3.amazonaws.com/", "")
    .replace("https://media.griptonite.io/", "");
  const parts = path.split("/");
  const prefix = parts[0];
  const stemPath = parts.slice(1).join("/").split(".")[0];
  return `https://media-processed.griptonite.io/${prefix}/transcode/720p/${stemPath}.jpg` as T extends
    | null
    | undefined
    ? null
    : string;
};

export default getThumbnailUrl;
